<template>
  <div class="b44-card b44-matriz-card">
    <div class="b44-matriz-head">
      <div>
        <h2 class="b44-h2">Matriz de Decisão Roboflex <HelpTip tip="det_matriz_card" wide /></h2>
        <p class="b44-muted">Planejamento × Execução</p>
      </div>
      <div class="b44-matriz-scores">
        <div class="b44-matriz-score right">
          <p class="b44-xs-muted">Planejamento <HelpTip tip="det_matriz_p" /></p>
          <p class="b44-score-num">{{ sp }}/10</p>
        </div>
        <span class="b44-times">×</span>
        <div class="b44-matriz-score">
          <p class="b44-xs-muted">Execução <HelpTip tip="det_matriz_e" /></p>
          <p class="b44-score-num">{{ se }}/10</p>
        </div>
      </div>
    </div>

    <div class="b44-matriz-status">
      <span class="b44-matriz-badge md" :class="cls === 'sem_classificacao' ? 'sem' : cls">{{ pillLabel }}</span>
      <p class="b44-matriz-desc" :class="cls">{{ currentCell.desc }}</p>
    </div>

    <div class="b44-matriz-grid-rich">
      <div></div>
      <div v-for="l in colLabels" :key="'col-' + l" class="b44-matriz-axis">Exec. {{ l }}</div>

      <template v-for="(row, ri) in celulas" :key="'row-' + ri">
        <div class="b44-matriz-axis row">Plan. {{ rowLabels[ri] }}</div>
        <div
          v-for="(cell, ci) in row"
          :key="'cell-' + ri + '-' + ci"
          class="b44-matriz-cell-rich"
          :class="[cell.key, { current: ri === planIdx && ci === execIdx }]"
        >
          <div class="b44-matriz-cell-top">
            <span class="b44-matriz-dot" :class="cell.key"></span>
            <span class="b44-matriz-cell-label">{{ labelOf(cell.key) }}</span>
          </div>
          <p class="b44-matriz-cell-desc">{{ cell.desc }}</p>
        </div>
      </template>
    </div>

    <p class="b44-matriz-footnote">Colunas: Execução &nbsp;·&nbsp; Linhas: Planejamento</p>
  </div>
</template>

<script>
import HelpTip from "@/components/PortfolioAuditor/HelpTip.vue";

const LABELS = {
  intervir: "INTERVIR",
  agir: "AGIR",
  ideal: "IDEAL",
  apoiar: "APOIAR",
  questionar: "QUESTIONAR",
  cancelar: "CANCELAR",
  sem_classificacao: "—",
};

export default {
  name: "MatrizQuadranteCard",
  components: { HelpTip },
  props: {
    projeto: { type: Object, required: true },
  },
  data() {
    return {
      rowLabels: ["7–10", "5–6", "0–4"],
      colLabels: ["0–4", "5–6", "7–10"],
      celulas: [
        [
          { key: "intervir", desc: "Primeiro da pauta. Plano bom, execução ruim." },
          { key: "agir", desc: "Monitorar de perto. Risco de deterioração." },
          { key: "ideal", desc: "Não entra na pauta. Reconhecer o desempenho." },
        ],
        [
          { key: "intervir", desc: "Plano fraco e execução ruim. Atenção urgente." },
          { key: "apoiar", desc: "Ajudar a melhorar o plano e a execução." },
          { key: "questionar", desc: "Por que está indo bem se o plano é fraco?" },
        ],
        [
          { key: "cancelar", desc: "Plano ruim e execução ruim. Candidato a cancelamento." },
          { key: "questionar", desc: "Execução razoável com plano ruim. Investigar." },
          { key: "questionar", desc: "Por que está indo bem se foi mal planejado?" },
        ],
      ],
    };
  },
  computed: {
    sp() {
      return this.projeto.score_planejamento ?? 0;
    },
    se() {
      return this.projeto.score_execucao ?? 0;
    },
    cls() {
      return this.projeto.classificacao_matriz || "sem_classificacao";
    },
    pillLabel() {
      return LABELS[this.cls] || "—";
    },
    planIdx() {
      return this.sp >= 7 ? 0 : this.sp >= 5 ? 1 : 2;
    },
    execIdx() {
      return this.se >= 7 ? 2 : this.se >= 5 ? 1 : 0;
    },
    currentCell() {
      return this.celulas[this.planIdx][this.execIdx];
    },
  },
  methods: {
    labelOf(key) {
      return LABELS[key] || key;
    },
  },
};
</script>
